/***
 * Created on 2024/10/1
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useEffect, useRef, useState} from 'react';
import ModalDialog from "../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import Captcha from "../../common/captcha";
import {useOnChange} from "common/Hook";
import {getErrorMessage} from "common/ServiceCommon";
import TextInput from "../../common/form/text_input";
import {useMutation, useQuery} from "@tanstack/react-query";
import {useCountdown} from "../../../hook/countdown";
import {apiGet, apiPost} from "../../../service/api";

function ChinaAddPhoneStep2({state, dispatch, ...props}) {
    const { t } = useTranslation();
    const {seconds, setSeconds} = useCountdown(0);
    const {values, onChange, setValues} = useOnChange({
        china_force_phone: true,
        country_code: '+86',
        mobile_number: state?.inputValues?.mobile_number,
        code: '',
        captcha: ''
    });
    const modalRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState('');

    const {data, isSuccess} = useQuery({
        queryKey: ['get_countdown'],
        queryFn: async () => await apiGet('/ajax/countdown')
    });

    const sendMobileCode = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/send_mobile_code', data),
        onSuccess: data => {
            setSeconds(60);
            dispatch({type: 'currentStep', value: 2, inputValues: values});
        },
        onError: (error, variables, context) => {
            console.error(error);
        }
    });

    const verifyMutation = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/verify_mobile', data),
        onSuccess: async data => {
            // await queryClient.invalidateQueries({
            //     queryKey: ['profile']
            // });
            // props.closeModal();
            // store.globalAlert.setAlert(t('@Activation successfully@'), 'success', true);
            dispatch({type: 'currentStep', value: 3, inputValues: values});
        },
        onError: (error, variables, context) => {
            setErrorMessage(getErrorMessage(t, error.cause?.code));
        }
    });

    const onVerify = async () => {
        setErrorMessage(null);
        await verifyMutation.mutateAsync(values);
    }

    const onResend = () => {
        sendMobileCode.mutate({
            country_code: '+86',
            mobile_number: state?.inputValues?.mobile_number,
        });
    }

    useEffect(() => {
        if (values?.code) {
            modalRef.current.disableSubmitButton(false);
        }
        else {
            modalRef.current.disableSubmitButton(true);
        }
    }, [values.code]);

    useEffect(() => {
        if (data && isSuccess) {
            const now = new Date().getTime();
            const value = Math.round((now - data?.countdown) / 1000) || 0;
            setSeconds(value > 60 ? 0 : 60 - value);
        }
    }, [data, isSuccess]);

    return (
        <ModalDialog {...props} title={t("@Add Your Phone Number@")} hideCancel={true} submitText={t("@Verify@")} submitAction={onVerify} ref={modalRef}>
            <div className="dialog-content">
                <div className="dialog__form-group">
                    <label>{t('@Phone number@')}</label>
                    <div className="comp-input">
                        <div className="input-field--hybrid">
                            <div className="comp-select lock">
                                <div className="q-select cursor-pointer">
                                    <div className="q-select__label">中國 (+86)</div>
                                    <div className="q-select__arrow"></div>
                                </div>
                            </div>
                            <TextInput
                                noWrap={true}
                                minLength={6} maxLength={11} pattern="[0-9]*"
                                name='mobile_number'
                                value={values.mobile_number}
                                onChange={onChange}
                                inputMode="numeric"
                                required={true}
                                clearStyle={true}/>
                        </div>
                    </div>
                </div>
                <ol className="list-style-type-disc ml-16">
                    <li>
                        <span
                            className="text-note">{t('@Please note that the QNAP ID (phone number) can only be used on QTS 4.3.4 or above.@')}</span>
                    </li>
                    <li>
                        <span
                            className="text-note">{t('@The phone number will not be saved before finishing the activation progress.@')}</span>
                    </li>
                </ol>
                <div className="dialog__form-group">
                    <label>{t('@Please check your SMS and enter the verification code in the box below@')}</label>
                    <div className="comp-input">
                        <div className="input-field--hybrid">
                            {/*<input type="text" className="input--must-fill input--invalid"/>*/}
                            <TextInput
                                noWrap={true}
                                name='code'
                                value={values.code}
                                onChange={onChange}
                                required={true}
                                clearStyle={true}/>
                            <button className="q-btn q-btn-default" disabled={seconds > 0} onClick={onResend}>
                                {seconds > 0 ? `${t('@Send@')} (${seconds})` : t('@Resend verification code@')}
                            </button>
                        </div>
                    </div>
                </div>

                <Captcha value={values.captcha} inputChangeHandler={onChange}
                         resetValue={() => setValues(prev => ({...prev, captcha: ''}))}/>

                {errorMessage && <p className="text-error">{errorMessage}</p>}

            </div>
        </ModalDialog>
    );
}

export default ChinaAddPhoneStep2;